import { KVPrimitiveGeometry, type KVPrimitiveGeometryType } from 'types'

export const MANUAL_PLACEMENT_INSTRUCTIONS: Record<
  KVPrimitiveGeometryType,
  string[]
> = {
  [KVPrimitiveGeometry.BOX]: [
    'Right-click to place the first corner of the base',
    'Right-click again to place the opposite corner of the base',
    'Right-click to set the height and complete the box',
  ],

  [KVPrimitiveGeometry.PLANE]: [
    'Right-click to place the first corner',
    'Right-click again to place the opposite corner',
  ],

  [KVPrimitiveGeometry.CYLINDER]: [
    'Right-click to set the height reference point (where the cylinder extends to)',
    'Right-click to place the first point on the base diameter',
    'Right-click to place the opposite point on the diameter and complete the cylinder',
  ],

  [KVPrimitiveGeometry.SPHERE]: [
    'Right-click to place the center of the sphere',
    'Right-click again to set the radius',
  ],
}
